import { render, staticRenderFns } from "./AppOrderSelector.vue?vue&type=template&id=35797e31&scoped=true"
import script from "./AppOrderSelector.vue?vue&type=script&lang=ts"
export * from "./AppOrderSelector.vue?vue&type=script&lang=ts"
import style0 from "./AppOrderSelector.vue?vue&type=style&index=0&id=35797e31&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35797e31",
  null
  
)

export default component.exports